<app-hero></app-hero>
<app-featured-products></app-featured-products>
<app-shop-by-category></app-shop-by-category>
<app-reviews></app-reviews>